import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import ReactTooltip from 'react-tooltip';

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './Skills.scss';


const Progress = ({ done }) => {
    const [style, setStyle] = useState({})

    setTimeout(() => {
        const newStyle = {
            opacity: 1,
            width: `${done}%`,
            color: "black",
            fontSize: "12px"

        }

        setStyle(newStyle);
    }, 200);

    return (
        <div className="progress">
            <div className="progress-done" style={style}>

            </div>
        </div>
    )
}


const Skills = () => {
    const [fntd, setFntd] = useState([])
    const [web3, setweb3] = useState([])
    const [bckd, setBckd] = useState([])
    const [ds, setDs] = useState([])
    const [ot, setOt] = useState([])

    useEffect(() => {

        const w = '*[_type == "web3"] | order(_createdAt asc)';
        const d = '*[_type == "ds"] | order(_createdAt asc)';
        const o = '*[_type == "skills"] | order(_createdAt asc)';

        client.fetch(w).then((data) => {
            setweb3(data)
        })
        client.fetch(d).then((data) => {
            setDs(data)
        })
        client.fetch(o).then((data) => {
            setOt(data)
        })


    }, [])

    return (
        <>
            <h2 className='head-text'>Skills / <span style={{ color: "var(--secondary-color);" }}>Experiences</span></h2>

            <div className="app__skills-container">

                <motion.div className="app__skills-list">
                    <h3 className='skill-category'>BlockChain Development</h3>

                    {web3.map((skill) => (
                        <div className='skill-item'>
                            <motion.div
                                whileInView={{ opacity: [0, 1] }}
                                transition={{ duration: 0.5 }}
                                className="app__skills-item app__flex"
                                key={skill.name}
                            >
                                <div
                                    className="app__flex"
                                    style={{ backgroundColor: skill.bgColor }}
                                >
                                    <img src={urlFor(skill.icon)} alt={skill.name} />
                                </div>
                                <p className="p-text" style={{ color: "black", fontSize: "1rem" }}>{skill.name}</p>
                            </motion.div>

                            <Progress done={skill.perc} />
                        </div>
                    ))}
                </motion.div>
                <motion.div className="app__skills-list">
                    <h3 className='skill-category'>Others</h3>

                    {ot.map((skill) => (
                        <div className='skill-item'>
                            <motion.div
                                whileInView={{ opacity: [0, 1] }}
                                transition={{ duration: 0.5 }}
                                className="app__skills-item app__flex"
                                key={skill.name}
                            >
                                <div
                                    className="app__flex"
                                    style={{ backgroundColor: skill.bgColor }}
                                >
                                    <img src={urlFor(skill.icon)} alt={skill.name} />
                                </div>
                                <p className="p-text" style={{ color: "black", fontSize: "1rem" }}>{skill.name}</p>
                            </motion.div>

                            <Progress done={skill.perc} />
                        </div>
                    ))}
                </motion.div>

            </div>

        </>
    );
}

export default AppWrap(
    MotionWrap(Skills, 'app__skills'),
    'skills',
    'app__whitebg',
);
